import Vue from 'vue/dist/vue.esm';
import Vuex from 'vuex';
import axios from 'axios';
import { createFlashStore } from 'vuex-flash';
import createPersistedState from 'vuex-persistedstate';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        data: [],
        err_data: [],
        err_message: '',
        create_account_data: [],
        search_accounts: [],
        search_enterprises: [],
        user_locations: [],
        search_enterprise_purchasing_history: {},
        multi_user_logged_in_time: '',
    },
    getters,
    mutations,
    actions,
    plugins: [
      createFlashStore(),
      createPersistedState({ storage: window.localStorage })
    ]
});



// WEBPACK FOOTER //
// ./src/store/store.js